import React from 'react';
import ReactSelect from 'react-select';
import { useFormikContext, useField } from 'formik';

import InputHeader from '../InputHeader';
import { StyledInputContainer } from '../styled';

import { ISelect } from './types';

import theme from '../../../../styles/userflow';

const customComponents = {
  ClearIndicator: () => null,
  IndicatorSeparator: () => null,
};

const styles = {
  control: (provided, state) => ({
    ...provided,
    height: '100%',
    boxShadow: 'none',
    border: `1px solid ${theme.colors.whiteLight}`,
    ':hover': {
      borderColor: theme.colors.whiteLight,
    },
    ...(state.isFocused
      ? {
          outline: `1px solid ${theme.colors.blue}`,
          position: 'absolute',
          zIndex: 9999,
          borderRadius: '4px',
          width: '100%',
        }
      : {}),
  }),
  container: provided => ({
    ...provided,
    height: '48px',
  }),
};

const Select: React.FC<ISelect> = props => {
  const {
    name,
    className = '',
    selectProps = {},
    header = '',
    placeholder = '',
    prependIcon,
  } = props;

  const [field] = useField(name);
  const { onBlur } = field;
  const { setFieldValue } = useFormikContext();

  return (
    <StyledInputContainer className={className}>
      <InputHeader text={header} prependIcon={prependIcon} />
      <ReactSelect
        components={customComponents}
        styles={styles}
        placeholder={placeholder}
        formatOptionLabel={(opt: LT.IOption) => opt.value}
        {...selectProps}
        onChange={option => setFieldValue(name, option)}
        onBlur={onBlur}
      />
    </StyledInputContainer>
  );
};

export default Select;
